export default "__VITE_ASSET__389788e5__"